import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const AudioWidgetStaticSchema = BaseWidgetSchema(WidgetType.Audio).extend({
  src: z.string(),
  title: z.string()
});

export type AudioWidgetStaticSchemaType = z.infer<typeof AudioWidgetStaticSchema>;
